export default __webpack_public_path__ + "static/media/Smoking Icon - Selected.05252a9d.svg";